module.exports = __webpack_public_path__ + "static/sendit-ce97e4d29bea44d02ce3bb6f932e128e.png";